import { render, staticRenderFns } from "./VueTaggableSelect.vue?vue&type=template&id=7f24a416&scoped=true"
import script from "./VueTaggableSelect.vue?vue&type=script&lang=js"
export * from "./VueTaggableSelect.vue?vue&type=script&lang=js"
import style0 from "./VueTaggableSelect.vue?vue&type=style&index=0&id=7f24a416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24a416",
  null
  
)

export default component.exports